import React from "react";

const ICON_LAYER = ({ color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9.9995 11.139"
    fill="none"
    {...props}
  >
    {/* Top Layer */}
    <path
      fill={color}
      d="m.17775 2.6823 4.394-2.578a.74.56658 0 0 1 .856 0l4.394 2.578c.237.13935.237.36292 0 .50227l-4.394 2.578a.74.56658 0 0 1-.856 0l-4.394-2.578c-.237-.13935-.237-.36292 0-.50227z"
      style={{ paintOrder: "markers fill stroke" }}
    />
    {/* Middle Layer */}
    <path
      fill={color}
      d="m.60275 5.0678-.425.2496c-.237.13935-.237.36369 0 .50227l4.394 2.5787a.74.56658 0 0 0 .857 0l4.392-2.5787c.237-.13858.237-.36292 0-.50227l-.426-.2496-3.967 2.3276a.74.56658 0 0 1-.857 0z"
      style={{ paintOrder: "markers fill stroke" }}
    />
    {/* Bottom Layer */}
    <path
      fill={color}
      d="m.60275 7.7039-.425.2496c-.237.13935-.237.36369 0 .50227l4.394 2.5787a.74.56658 0 0 0 .857 0l4.392-2.5787c.237-.13858.237-.36292 0-.50227l-.426-.2496-3.967 2.3276a.74.56658 0 0 1-.857 0z"
      style={{ paintOrder: "markers fill stroke" }}
    />
  </svg>
);

export default ICON_LAYER;
